import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import Dropdown, { DropdownDivider, DropdownItem } from './Dropdown/Dropdown';
import { ReactComponent as EllipsisVertical } from '../../icons/more-vert.svg';
import { ReactComponent as PageEditIcon } from '../../icons/page-edit.svg';
import { ReactComponent as DeleteIcon } from '../../icons/xmark-circle.svg';
import { ReactComponent as PrintIcon } from '../../icons/printer.svg';
import { ReactComponent as ShareIcon } from '../../icons/share-ios.svg';

import './Options.scss';

// onPrint and onShare are opt-in: this menu is shared with the song list, which has neither
const Options = ({ item, onDelete, onEdit, onPrint, onShare, editId, deleteDisabled }) => {
  const { t } = useTranslation();

  if (editId) return null;

  const handleEdit = () => onEdit(item);

  const handleDelete = () => {
    if (deleteDisabled) {
      toast.warn(t('songs.removeFromServicesFirst'));
    } else {
      onDelete(item);
    }
  };

  return (
    <div className="Options">
      <Dropdown
        align="right"
        // Portalled: the song list's rounded surface clips, and the last row's menu was cut off
        portal
        menuClassName="options-menu"
        triggerClassName="option-icon"
        trigger={<Icon icon={<EllipsisVertical />} className="options-icon" />}
      >
        <DropdownItem shortcut="e" onClick={handleEdit}>
          <Icon className="options__icon" icon={<PageEditIcon />} />
          <span>{t('common.edit')}</span>
        </DropdownItem>
        {onPrint && (
          <DropdownItem shortcut="p" onClick={() => onPrint(item)}>
            <Icon className="options__icon" icon={<PrintIcon />} />
            <span>{t('common.print')}</span>
          </DropdownItem>
        )}
        {onShare && (
          <DropdownItem shortcut="s" onClick={() => onShare(item)}>
            <Icon className="options__icon" icon={<ShareIcon />} />
            <span>{t('common.share')}</span>
          </DropdownItem>
        )}
        <DropdownDivider />
        <DropdownItem className="options__delete" shortcut="d" onClick={handleDelete}>
          <Icon className="options__icon" icon={<DeleteIcon />} />
          <span>{t('common.delete')}</span>
        </DropdownItem>
      </Dropdown>
    </div>
  );
};

export default Options;
